    // ---------------------------------------------------------------------------
    // Configuration injected by the section template (see mm-fragrance-finder.liquid).
    // Expected shape:
    //   window.MM_FF = {
    //     fragrances: { A: {image, link, ...}, B: {...}, C: {...}, D: {...} },
    //     sets:       [{name, image, link, character}, ...],
    //     bgImages:   { intro, q0, q1, q2, q3, q4, q5, q6, q7, q8 }, // url per key
    //     endpoints:  { capture, exitIntent } // optional Klaviyo/Shopify endpoints
    //   };
    // If MM_FF is missing, we fall back to embedded defaults so this file remains
    // viewable in isolation while you wire things up.
    // ---------------------------------------------------------------------------
    var MM_FF = (typeof window !== 'undefined' && window.MM_FF) || {};
    var FRAG_IMG = (MM_FF.fragrances) || {};
    var SET_DATA = MM_FF.sets || [];

    var FRAGRANCES = {
      A: {
        id: 'rough-riders', name: 'Rough Riders', price: '$350',
        character: 'Balanced, worn-in, familiar with depth',
        notes: ['Dark Tobacco', 'Pineapple', 'Sandalwood'],
        about: 'On the furthest stretch of land, a rugged spirit remains. Named for Teddy Roosevelt’s Rough Riders, who came to Montauk as a place of refuge after the Spanish-American War in 1898. The fragrance carries echoes of their journey—translated into a scent of subtle strength.',
        image: (FRAG_IMG.A && FRAG_IMG.A.image) || 'assets/Rough Riders.png',
        link:  (FRAG_IMG.A && FRAG_IMG.A.link)  || 'https://montaukman.com/products/rough-riders-90ml',
        variantId: (FRAG_IMG.A && FRAG_IMG.A.variantId) || null
      },
      B: {
        id: 'twice-light', name: 'Twice Light', price: '$350',
        character: 'Bright, energetic, open',
        notes: ['Bergamot', 'Neroli', 'Lavender', 'Ginger'],
        about: 'A double illumination of sky and sea, reflecting forces meet. Inspired by the double illumination of light in Montauk, where sun bounces off water and the sky seems to meet itself. This is what artists and photographers chase out to the end of the island.',
        image: (FRAG_IMG.B && FRAG_IMG.B.image) || 'assets/Twice Light.png',
        link:  (FRAG_IMG.B && FRAG_IMG.B.link)  || 'https://montaukman.com/products/twice-light-90ml',
        variantId: (FRAG_IMG.B && FRAG_IMG.B.variantId) || null
      },
      C: {
        id: 'north-bar', name: 'North Bar', price: '$350',
        character: 'Dark, restrained, complex',
        notes: ['Dark Oud', 'Saffron', 'Black Leather'],
        about: 'On the northern edge of the coast, swells rise and fold with an unstoppable force. Named for a local surf spot past the lighthouse—a rocky beach that only breaks in winter when the winds shift. You will not find it on any map.',
        image: (FRAG_IMG.C && FRAG_IMG.C.image) || 'assets/North Bar.png',
        link:  (FRAG_IMG.C && FRAG_IMG.C.link)  || 'https://montaukman.com/products/north-bar',
        variantId: (FRAG_IMG.C && FRAG_IMG.C.variantId) || null
      },
      D: {
        id: 'amber-boom', name: 'Amber Boom', price: '$350',
        character: 'Warm, intimate, lingering',
        notes: ['Radiant Amber', 'Black Cherry', 'Tonka Bean'],
        about: 'Light and shadow blend, as dusk descends. Captures the golden hour on Montauk—that quality of light when everything glows amber. A scent that develops over hours, growing warmer and softer against your skin as the day wears on.',
        image: (FRAG_IMG.D && FRAG_IMG.D.image) || 'assets/Amber Boom.png',
        link:  (FRAG_IMG.D && FRAG_IMG.D.link)  || 'https://montaukman.com/products/amber-boom-90ml',
        variantId: (FRAG_IMG.D && FRAG_IMG.D.variantId) || null
      }
    };

    // Sets — sit alongside the 4 fragrances in the bottom collection grid.
    var COLLECTION_SETS = SET_DATA.length ? SET_DATA : [
      {
        name: 'Discovery Set',
        character: '2ml × 4 Scents · $40',
        image: 'assets/discovery-set.png',
        link: 'https://montaukman.com/products/discovery-set'
      },
      {
        name: 'Travel Set',
        character: '10ml × 4 Scents · $180',
        image: 'assets/travel-set.png',
        link: 'https://montaukman.com/products/travel-set'
      }
    ];

    // Fragrance keys: A = Rough Riders, B = Twice Light, C = North Bar, D = Amber Boom.
    // weights map per-answer fragrance points (primary +2, secondary +1, tertiary +0.5).
    // Each question references a bg key that maps to a background photo in the bg-layer.
    var QUESTIONS = [
      { text: 'How do you want your fragrance to make you feel?', bg: 'q0', answers: [
        { key: 'A', text: 'Grounded and confident',   weights: { A: 2 } },
        { key: 'B', text: 'Airy and playful',         weights: { B: 2 } },
        { key: 'C', text: 'Mysterious and dangerous', weights: { C: 2 } },
        { key: 'D', text: 'Magnetic and sexy',        weights: { D: 2 } }
      ]},
      { text: 'Which kind of night pulls you in?', bg: 'q1', answers: [
        { key: 'A', text: 'A casual dinner that turns into a long night', weights: { A: 2, D: 1 } },
        { key: 'B', text: 'Drinks outside in warm weather',               weights: { B: 2, A: 1 } },
        { key: 'C', text: 'A dressy night out in the city',               weights: { C: 2, A: 1 } },
        { key: 'D', text: 'Hosting friends late into the evening',        weights: { D: 2, A: 1 } }
      ]},
      { text: 'When do you want your fragrance noticed?', bg: 'q2', answers: [
        { key: 'A', text: 'Out and about in Soho',           weights: { A: 2 } },
        { key: 'B', text: 'By the pool in Mustique',         weights: { B: 2 } },
        { key: 'C', text: 'At a wedding in Napa',            weights: { C: 2 } },
        { key: 'D', text: 'The morning after in Amagansett', weights: { D: 2 } }
      ]},
      { text: 'Pick a uniform.', bg: 'q3', answers: [
        { key: 'A', text: 'Faded denim and a baseball cap',         weights: { A: 2 } },
        { key: 'B', text: 'Relaxed linen and worn-in chinos',       weights: { B: 2 } },
        { key: 'C', text: 'Dark suede, heavy texture, clean lines', weights: { C: 2 } },
        { key: 'D', text: 'A cashmere sweater and corduroys',       weights: { D: 2 } }
      ]},
      { text: 'How do you typically wear fragrance?', bg: 'q4', answers: [
        { key: 'A', text: 'I want one signature scent',             weights: { A: 2 } },
        { key: 'B', text: 'I rotate depending on season or mood',   weights: { B: 2, C: 1, D: 1 } },
        { key: 'C', text: 'I wear different scents day vs. night',  weights: { B: 1, C: 1 } },
        { key: 'D', text: 'I want fragrance to match the occasion', weights: { C: 2, D: 1, B: 1 } }
      ]},
      { text: 'What keeps you coming back to a fragrance?', bg: 'q5', answers: [
        { key: 'A', text: 'Versatility',     weights: { A: 2, B: 1 } },
        { key: 'B', text: 'Freshness',       weights: { B: 2 } },
        { key: 'C', text: 'Distinctiveness', weights: { C: 2 } },
        { key: 'D', text: 'Sensuality',      weights: { D: 2 } }
      ]}
    ];

    var currentQ = 0;
    var userAnswers = [null, null, null, null, null, null];
    var activeScreen = 'intro';

    // Intro is active on first paint — prevent scrolling on the landing screen.
    document.body.classList.add('body--lock-scroll');

    var screens = {
      intro: document.getElementById('screen-intro'),
      question: document.getElementById('screen-question'),
      emailgate: document.getElementById('screen-emailgate'),
      result: document.getElementById('screen-result')
    };
    var $qText = document.getElementById('questionText');
    var $answers = document.getElementById('answersContainer');
    var $fill = document.getElementById('progressFill');
    var $count = document.getElementById('progressCount');
    var $nav = document.getElementById('questionNav');

    function showScreen(name) {
      screens[activeScreen].classList.remove('screen--active');
      setTimeout(function() {
        screens[name].classList.add('screen--active');
        activeScreen = name;
        // Lock page scroll only on the intro landing screen. Other screens scroll
        // normally so the theme footer at the bottom of the page stays reachable.
        document.body.classList.toggle('body--lock-scroll', name === 'intro');
        window.scrollTo({ top: 0, behavior: 'instant' });
      }, 400);
    }

    function setQuestionBg(key) {
      var imgs = document.querySelectorAll('.question-bg__img');
      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i].dataset.bg === key) imgs[i].classList.add('question-bg__img--active');
        else imgs[i].classList.remove('question-bg__img--active');
      }
    }

    // Fisher-Yates shuffle applied to each question's answers. Called at quiz start
    // and on retake so a new random order is presented each session.
    function shuffleAnswers() {
      for (var q = 0; q < QUESTIONS.length; q++) {
        var a = QUESTIONS[q].answers.slice();
        for (var i = a.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
        }
        QUESTIONS[q].answers = a;
      }
    }

    function renderQuestion() {
      var q = QUESTIONS[currentQ];
      $fill.style.width = ((currentQ + 1) / QUESTIONS.length * 100) + '%';
      $count.textContent = (currentQ + 1) + ' / ' + QUESTIONS.length;
      setQuestionBg(q.bg);

      $qText.classList.remove('question__text--visible');
      $answers.classList.remove('answers--visible');

      setTimeout(function() {
        $qText.textContent = q.text;
        $answers.innerHTML = '';
        for (var i = 0; i < q.answers.length; i++) {
          (function(a, idx) {
            var btn = document.createElement('button');
            btn.className = 'answer';
            if (userAnswers[currentQ] === a.key) btn.classList.add('answer--selected');
            var displayLetter = String.fromCharCode(65 + idx); // 0->A, 1->B, 2->C, 3->D
            btn.innerHTML =
              '<span class="answer__letter">' + displayLetter + '</span>' + a.text;
            btn.style.opacity = '0';
            btn.style.transform = 'translateY(5px)';
            setTimeout(function() {
              btn.style.transition = 'opacity 0.35s ease, transform 0.35s ease, color 0.25s ease';
              btn.style.opacity = '1';
              btn.style.transform = 'translateY(0)';
            }, 30 + idx * 55);
            btn.addEventListener('click', function() { selectAnswer(a.key); });
            $answers.appendChild(btn);
          })(q.answers[i], i);
        }
        requestAnimationFrame(function() {
          $qText.classList.add('question__text--visible');
          $answers.classList.add('answers--visible');
        });
      }, 220);

      $nav.style.visibility = currentQ === 0 ? 'hidden' : 'visible';
    }

    function selectAnswer(key) {
      userAnswers[currentQ] = key;
      var btns = $answers.querySelectorAll('.answer');
      for (var i = 0; i < btns.length; i++) {
        if (QUESTIONS[currentQ].answers[i].key === key) btns[i].classList.add('answer--selected');
        else btns[i].classList.remove('answer--selected');
      }
      setTimeout(function() {
        if (currentQ < QUESTIONS.length - 1) { currentQ++; renderQuestion(); }
        else showEmailGate();
      }, 350);
    }

    function calculateResult() {
      var scores = { A: 0, B: 0, C: 0, D: 0 };
      for (var i = 0; i < userAnswers.length; i++) {
        if (!userAnswers[i]) continue;
        var answers = QUESTIONS[i].answers, picked = null;
        for (var j = 0; j < answers.length; j++) {
          if (answers[j].key === userAnswers[i]) { picked = answers[j]; break; }
        }
        if (!picked || !picked.weights) continue;
        for (var k in picked.weights) {
          scores[k] = (scores[k] || 0) + picked.weights[k];
        }
      }
      var primary = 'A', primaryScore = -Infinity;
      for (var k in scores) { if (scores[k] > primaryScore) { primaryScore = scores[k]; primary = k; } }
      var secondary = null, secondaryScore = -Infinity;
      for (var k in scores) {
        if (k === primary) continue;
        if (scores[k] > 0 && primaryScore - scores[k] <= 2 && scores[k] > secondaryScore) {
          secondaryScore = scores[k];
          secondary = k;
        }
      }
      return { primary: primary, secondary: secondary, scores: scores };
    }

    function showResult() {
      var res = calculateResult();
      var key = res.primary;
      var frag = FRAGRANCES[key];

      document.getElementById('resultEyebrow').textContent = res.secondary ? "You're Primarily…" : 'Your Fragrance';
      document.getElementById('resultName').textContent = frag.name;
      document.getElementById('captureHeading').textContent = 'First word on ' + frag.name + ' restocks and editorial drops.';
      document.getElementById('resultCapture').classList.remove('result__capture--submitted');
      document.getElementById('captureEmail').value = '';
      document.getElementById('resultCharacter').textContent = frag.character;
      document.getElementById('resultAbout').textContent = frag.about;
      var $notes = document.getElementById('resultNotes');
      $notes.innerHTML = '';
      for (var i = 0; i < frag.notes.length; i++) {
        $notes.innerHTML += '<span class="result__note-tag">' + frag.notes[i] + '</span>';
      }

      var $bottle = document.getElementById('resultImage');
      $bottle.src = frag.image;
      $bottle.alt = frag.name;
      $bottle.classList.remove('result__bottle--visible');

      var $info = document.getElementById('resultInfo');
      $info.classList.remove('result__info--visible');

      var $shopBtn = document.getElementById('resultShopBtn');
      $shopBtn.href = frag.link; // fallback (no-JS, middle-click, or add-to-cart failure)
      $shopBtn.dataset.variantId = frag.variantId || '';

      // Secondary "Also Worth Exploring"
      var $secondary = document.getElementById('resultSecondary');
      if (res.secondary) {
        var sf = FRAGRANCES[res.secondary];
        document.getElementById('secondaryImage').src = sf.image;
        document.getElementById('secondaryImage').alt = sf.name;
        document.getElementById('secondaryName').textContent = sf.name;
        document.getElementById('secondaryCharacter').textContent = sf.character;
        var $sNotes = document.getElementById('secondaryNotes');
        $sNotes.innerHTML = '';
        for (var n = 0; n < sf.notes.length; n++) {
          $sNotes.innerHTML += '<span class="result__note-tag">' + sf.notes[n] + '</span>';
        }
        document.getElementById('secondaryShop').href = sf.link;
        $secondary.classList.remove('result__secondary--hidden');
      } else {
        $secondary.classList.add('result__secondary--hidden');
      }

      // Collection grid: always 4 cards.
      // - Skip the primary (it's the hero) and the secondary (it's in "Also Worth Exploring").
      // - Fill order: remaining 90MLs, then Discovery, then Travel.
      // - No secondary  → 3 fragrances + Discovery (Travel excluded).
      // - Has secondary → 2 fragrances + Discovery + Travel.
      var $grid = document.getElementById('othersGrid');
      $grid.innerHTML = '';
      var fragKeys = ['A','B','C','D'];
      var pool = [];
      for (var j = 0; j < fragKeys.length; j++) {
        if (fragKeys[j] === key) continue;
        if (fragKeys[j] === res.secondary) continue;
        pool.push(FRAGRANCES[fragKeys[j]]);
      }
      for (var s = 0; s < COLLECTION_SETS.length; s++) pool.push(COLLECTION_SETS[s]);
      var items = pool.slice(0, 4);

      for (var c = 0; c < items.length; c++) {
        var f = items[c];
        var card = document.createElement('a');
        card.className = 'result__card';
        card.href = f.link;
        card.innerHTML =
          '<img class="result__card-img" src="' + f.image + '" alt="' + f.name + '">' +
          '<p class="result__card-name">' + f.name + '</p>' +
          '<p class="result__card-char">' + f.character + '</p>';
        $grid.appendChild(card);
      }

      showScreen('result');
      setTimeout(function() {
        $bottle.classList.add('result__bottle--visible');
        $info.classList.add('result__info--visible');
      }, 500);
    }

    document.getElementById('startBtn').addEventListener('click', function() {
      shuffleAnswers();
      showScreen('question');
      setTimeout(renderQuestion, 450);
    });

    document.getElementById('prevBtn').addEventListener('click', function() {
      if (currentQ > 0) { currentQ--; renderQuestion(); }
    });

    document.getElementById('retakeBtn').addEventListener('click', function() {
      currentQ = 0;
      userAnswers = [null, null, null, null, null, null];
      shuffleAnswers();
      showScreen('intro');
    });

    // Result "Add to Cart": add the matched fragrance's default variant to the
    // cart and open the theme's cart drawer. The button's variant id is set per
    // result in renderResult(). Falls back to navigating to the PDP (the button's
    // href) if there's no variant id or the request fails.
    (function() {
      var shopBtn = document.getElementById('resultShopBtn');
      if (!shopBtn) return;
      shopBtn.addEventListener('click', function(e) {
        var variantId = shopBtn.dataset.variantId;
        if (!variantId) return; // no variant → let the <a> navigate to the PDP
        e.preventDefault();
        if (shopBtn.dataset.adding === '1') return;
        shopBtn.dataset.adding = '1';
        var cartDrawer = document.querySelector('cart-drawer');
        var sections = (cartDrawer && cartDrawer.getSectionsToRender)
          ? cartDrawer.getSectionsToRender().map(function(s) { return s.section; })
          : [];
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: sections,
            sections_url: window.location.pathname
          })
        })
        .then(function(r) { return r.json(); })
        .then(function(res) {
          shopBtn.dataset.adding = '';
          if (res.status) { window.location.href = shopBtn.getAttribute('href'); return; } // add error → PDP
          if (cartDrawer && cartDrawer.renderContents) { cartDrawer.renderContents(res); }
          else { window.location.href = '/cart'; } // no drawer on page → go to cart
        })
        .catch(function() {
          shopBtn.dataset.adding = '';
          window.location.href = shopBtn.getAttribute('href');
        });
      });
    })();

    function showEmailGate() {
      document.getElementById('emailGateEmail').value = '';
      showScreen('emailgate');
    }

    // Email gate — fires after the last question, before the result page.
    // Submitting captures the email then surfaces the result. Skip goes
    // straight to the result. Uses MM_FF.endpoints.capture by default.
    document.getElementById('emailGateForm').addEventListener('submit', function(e) {
      e.preventDefault();
      var email = document.getElementById('emailGateEmail').value.trim();
      if (!email || email.indexOf('@') < 1) {
        document.getElementById('emailGateEmail').focus();
        return;
      }
      var payload = {
        email: email,
        source: 'fragrance_finder_email_gate',
        fragrance: (calculateResult().primary || '')
      };
      var endpoint = MM_FF.endpoints && (MM_FF.endpoints.emailGate || MM_FF.endpoints.capture);
      if (endpoint) {
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        }).catch(function(err) { console.warn('FF email-gate failed:', err); });
      } else {
        console.log('[MM_FF] Email-gate capture (no endpoint wired):', payload);
      }
      showResult();
    });

    document.getElementById('emailGateSkip').addEventListener('click', function() {
      showResult();
    });

    // Email capture form (inline strip on the result page).
    // To wire up: set MM_FF.endpoints.capture to a Klaviyo list endpoint or your
    // own subscribe handler. We POST JSON { email, source, fragrance }.
    document.getElementById('captureForm').addEventListener('submit', function(e) {
      e.preventDefault();
      var email = document.getElementById('captureEmail').value.trim();
      if (!email || email.indexOf('@') < 1) {
        document.getElementById('captureEmail').focus();
        return;
      }
      var payload = {
        email: email,
        source: 'fragrance_finder_result',
        fragrance: (calculateResult().primary || '')
      };
      var endpoint = MM_FF.endpoints && MM_FF.endpoints.capture;
      if (endpoint) {
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        }).catch(function(err) { console.warn('FF capture failed:', err); });
      } else {
        console.log('[MM_FF] Capture (no endpoint wired):', payload);
      }
      document.getElementById('resultCapture').classList.add('result__capture--submitted');
    });

    // Header scroll + hamburger are handled by the global theme header
    // (sections/mm-header.liquid). The finder no longer renders its own header,
    // so this block was removed to avoid double-binding the shared mmHeader/mmHamburger elements.

    // Exit-intent modal — once per session, only on result screen
    (function() {
      var modal = document.getElementById('exitModal');
      var backdrop = document.getElementById('exitModalBackdrop');
      var closeBtn = document.getElementById('exitModalClose');
      var form = document.getElementById('exitModalForm');
      var emailInput = document.getElementById('exitModalEmail');
      var shown = false;

      function show() {
        if (shown || activeScreen !== 'result') return;
        shown = true;
        modal.classList.add('exit-modal--visible');
      }
      function hide() {
        modal.classList.remove('exit-modal--visible');
      }

      // Desktop trigger — cursor leaves toward top of viewport
      document.addEventListener('mouseleave', function(e) {
        if (e.clientY <= 5) show();
      });

      backdrop.addEventListener('click', hide);
      closeBtn.addEventListener('click', hide);
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.classList.contains('exit-modal--visible')) hide();
      });

      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var email = emailInput.value.trim();
        if (!email || email.indexOf('@') < 1) { emailInput.focus(); return; }
        var payload = {
          email: email,
          source: 'fragrance_finder_exit_intent',
          fragrance: (calculateResult().primary || '')
        };
        var endpoint = MM_FF.endpoints && (MM_FF.endpoints.exitIntent || MM_FF.endpoints.capture);
        if (endpoint) {
          fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          }).catch(function(err) { console.warn('FF exit-intent failed:', err); });
        } else {
          console.log('[MM_FF] Exit-intent capture (no endpoint wired):', payload);
        }
        modal.classList.add('exit-modal--submitted');
        setTimeout(hide, 2500);
      });
    })();

    // Keyboard shortcuts (1-4 for answers, Backspace = previous)
    document.addEventListener('keydown', function(e) {
      if (activeScreen !== 'question') return;
      var map = { '1': 0, '2': 1, '3': 2, '4': 3 };
      if (e.key in map) selectAnswer(QUESTIONS[currentQ].answers[map[e.key]].key);
      if (e.key === 'Backspace' && currentQ > 0) { e.preventDefault(); currentQ--; renderQuestion(); }
    });
